module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "left.3207b72d.svg";